var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 0H5.5C2.46 0 0 2.46 0 5.5V38.5C0 41.54 2.46 44 5.5 44H38.5C41.54 44 44 41.54 44 38.5V5.5C44 2.46 41.54 0 38.5 0Z",
    stroke: "#FFFFFE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 36.6667H8.33333V16.3333H14.6667V36.6667Z",
    stroke: "#FFFFFE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.75C9.29 13.75 7.5 11.96 7.5 9.75C7.5 7.54 9.29 5.75 11.5 5.75C13.71 5.75 15.5 7.54 15.5 9.75C15.5 11.96 13.71 13.75 11.5 13.75Z",
    stroke: "#FFFFFE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 36.6667H30.3333V26.5C30.3333 23.16 30.3 18.93 26.13 18.93C21.96 18.93 21.3333 22.39 21.3333 26.3V36.6667H15V16.3333H21.0333V20.36H21.1333C22.33 17.93 25.5 16.3333 29.3 16.3333C37.1333 16.3333 38.5 21.83 38.5 25.5V36.6667H36.6667Z",
    stroke: "#FFFFFE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f2fc1fc069f76a571d2153cbf13bd3d8.svg";
export { ForwardRef as ReactComponent };